import React from 'react';
import {Button, Drawer} from "@mui/material";
import LandingCommunityLogsUpdateIssued from "./LandingCommunityLogsUpdateIssued";
import LandingCommunityLogsUpdateRedeemed from "./LandingCommunityLogsUpdateRedeemed";

export default function LandingCommunityLogsUpdate({ open,setOpen, row,mode, setLoading,setRefreshTrigger }) {

    const [mode1,setMode1] = React.useState(mode || 'issued');

    return (
        <Drawer anchor={"right"} open={open} onClose={() => setOpen(false)}>
            <div style={{padding:20, width:400}}>

                <div style={{display:'flex'}}>
                    <Button disabled={mode1 === 'issued'} onClick={() => setMode1('issued')} >Issued</Button>
                    <Button disabled={mode1 === 'redeemed'} onClick={() => setMode1('redeemed')} >Redeemed</Button>
                </div>

                {mode1 === 'issued' && <LandingCommunityLogsUpdateIssued row={row} setOpen={setOpen} setLoading={setLoading}  setRefreshTrigger={setRefreshTrigger} />}
                {mode1 === 'redeemed' && <LandingCommunityLogsUpdateRedeemed row={row} setOpen={setOpen} setLoading={setLoading} setRefreshTrigger={setRefreshTrigger} />}

            </div>
        </Drawer>
    )
}
